<template>
  <div id="printable-admission-note" class="admission-note-print">
    <div class="header">
      <h1>{{ $brand.nameEnPrint }}</h1>
      <h2>ADMISSION NOTE</h2>
    </div>

    <table class="admission-table" style="width: 100%; border-collapse: collapse; border: 2px solid #000; margin-bottom: 15px;">
      <tbody>
        <!-- Row 1 -->
        <tr>
          <td class="label-cell" style="border: 1px solid #000; padding: 6px 8px; font-weight: bold; background: #f8f9fa; text-transform: uppercase; font-size: 10pt;">TOB:</td>
          <td class="value-cell" style="border: 1px solid #000; padding: 6px 8px; background: white; font-size: 11pt;">{{ getNoteValue('tob') }}</td>
          <td class="label-cell" style="border: 1px solid #000; padding: 6px 8px; font-weight: bold; background: #f8f9fa; text-transform: uppercase; font-size: 10pt;">TOA:</td>
          <td class="value-cell" style="border: 1px solid #000; padding: 6px 8px; background: white; font-size: 11pt;">{{ getNoteValue('toa') }}</td>
        </tr>

        <!-- Row 2 -->
        <tr>
          <td class="label-cell" style="border: 1px solid #000; padding: 6px 8px; font-weight: bold; background: #f8f9fa; text-transform: uppercase; font-size: 10pt;">DOB:</td>
          <td class="value-cell" style="border: 1px solid #000; padding: 6px 8px; background: white; font-size: 11pt;">{{ getNoteValue('dob') }}</td>
          <td class="label-cell" style="border: 1px solid #000; padding: 6px 8px; font-weight: bold; background: #f8f9fa; text-transform: uppercase; font-size: 10pt;">DOA:</td>
          <td class="value-cell" style="border: 1px solid #000; padding: 6px 8px; background: white; font-size: 11pt;">{{ getNoteValue('doa') }}</td>
        </tr>

        <!-- Row 3 -->
        <tr>
          <td class="label-cell" style="border: 1px solid #000; padding: 6px 8px; font-weight: bold; background: #f8f9fa; text-transform: uppercase; font-size: 10pt;">PATIENT NAME:</td>
          <td class="value-cell" style="border: 1px solid #000; padding: 6px 8px; background: white; font-size: 11pt;">{{ getNoteValue('patient_name') }}</td>
          <td class="label-cell" style="border: 1px solid #000; padding: 6px 8px; font-weight: bold; background: #f8f9fa; text-transform: uppercase; font-size: 10pt;">WT:</td>
          <td class="value-cell" style="border: 1px solid #000; padding: 6px 8px; background: white; font-size: 11pt;">{{ getNoteValue('wt') }}</td>
        </tr>

        <!-- Row 4 -->
        <tr>
          <td class="label-cell" style="border: 1px solid #000; padding: 6px 8px; font-weight: bold; background: #f8f9fa; text-transform: uppercase; font-size: 10pt;">AGE:</td>
          <td class="value-cell" style="border: 1px solid #000; padding: 6px 8px; background: white; font-size: 11pt;">{{ getNoteValue('age') || patientAge }}</td>
          <td class="label-cell" style="border: 1px solid #000; padding: 6px 8px; font-weight: bold; background: #f8f9fa; text-transform: uppercase; font-size: 10pt;">REFERRO FROM:</td>
          <td class="value-cell" style="border: 1px solid #000; padding: 6px 8px; background: white; font-size: 11pt;">{{ getNoteValue('referro_from') }}</td>
        </tr>

        <!-- Row 5 -->
        <tr>
          <td class="label-cell" style="border: 1px solid #000; padding: 6px 8px; font-weight: bold; background: #f8f9fa; text-transform: uppercase; font-size: 10pt;">PEDIATRISIAN S:</td>
          <td class="value-cell" style="border: 1px solid #000; padding: 6px 8px; background: white; font-size: 11pt;">{{ getNoteValue('pediatrician_s') }}</td>
          <td class="label-cell" style="border: 1px solid #000; padding: 6px 8px; font-weight: bold; background: #f8f9fa; text-transform: uppercase; font-size: 10pt;">PEDIATRICIAN P:</td>
          <td class="value-cell" style="border: 1px solid #000; padding: 6px 8px; background: white; font-size: 11pt;">{{ getNoteValue('pediatrician_p') }}</td>
        </tr>

        <!-- Row 6 -->
        <tr>
          <td class="label-cell" style="border: 1px solid #000; padding: 6px 8px; font-weight: bold; background: #f8f9fa; text-transform: uppercase; font-size: 10pt;">CC:</td>
          <td class="value-cell large-cell" colspan="3" style="border: 1px solid #000; padding: 6px 8px; background: white; font-size: 11pt; min-height: 60px;">{{ getNoteValue('cc') }}</td>
        </tr>

        <!-- Row 7 -->
        <tr>
          <td class="label-cell" rowspan="2" style="border: 1px solid #000; padding: 6px 8px; font-weight: bold; background: #f8f9fa; text-transform: uppercase; font-size: 10pt;">GA:</td>
          <td class="value-cell small-cell" style="border: 1px solid #000; padding: 6px 8px; background: white; font-size: 10pt;">
            <span class="inline-label" style="font-weight: bold; margin-right: 5px;">G</span> {{ getNoteValue('g') }}
            <span class="inline-label ml" style="font-weight: bold; margin-left: 15px; margin-right: 5px;">P</span> {{ getNoteValue('p') }}
            <span class="inline-label ml" style="font-weight: bold; margin-left: 15px; margin-right: 5px;">A</span> {{ getNoteValue('a') }}
          </td>
          <td class="label-cell" style="border: 1px solid #000; padding: 6px 8px; font-weight: bold; background: #f8f9fa; text-transform: uppercase; font-size: 10pt;">GHT</td>
          <td class="value-cell" style="border: 1px solid #000; padding: 6px 8px; background: white; font-size: 11pt;">{{ getNoteValue('ght') }}</td>
        </tr>

        <!-- Row 8 -->
        <tr>
          <td class="label-cell" style="border: 1px solid #000; padding: 6px 8px; font-weight: bold; background: #f8f9fa; text-transform: uppercase; font-size: 10pt;">BRIEF NOTE:</td>
          <td class="label-cell" style="border: 1px solid #000; padding: 6px 8px; font-weight: bold; background: #f8f9fa; text-transform: uppercase; font-size: 10pt;">GDM</td>
          <td class="value-cell" style="border: 1px solid #000; padding: 6px 8px; background: white; font-size: 11pt;">{{ getNoteValue('gdm') }}</td>
        </tr>

        <!-- Row 9 - Brief Note Content -->
        <tr>
          <td class="value-cell large-cell" colspan="2" rowspan="3" style="border: 1px solid #000; padding: 6px 8px; background: white; font-size: 11pt; min-height: 60px;">
            {{ getNoteValue('brief_note') }}
          </td>
          <td class="label-cell" style="border: 1px solid #000; padding: 6px 8px; font-weight: bold; background: #f8f9fa; text-transform: uppercase; font-size: 10pt;">APH</td>
          <td class="value-cell" style="border: 1px solid #000; padding: 6px 8px; background: white; font-size: 11pt;">{{ getNoteValue('aph') }}</td>
        </tr>

        <!-- Row 10 -->
        <tr>
          <td class="empty-cell" style="border: 1px solid #000; padding: 6px 8px; background: white;"></td>
          <td class="empty-cell" style="border: 1px solid #000; padding: 6px 8px; background: white;"></td>
        </tr>

        <!-- Row 11 -->
        <tr>
          <td class="label-cell" style="border: 1px solid #000; padding: 6px 8px; font-weight: bold; background: #f8f9fa; text-transform: uppercase; font-size: 10pt;">L.L</td>
          <td class="value-cell" style="border: 1px solid #000; padding: 6px 8px; background: white; font-size: 11pt;">{{ getNoteValue('ll') }}</td>
        </tr>

        <!-- Row 12 -->
        <tr>
          <td class="empty-cell" colspan="2" style="border: 1px solid #000; padding: 6px 8px; background: white;"></td>
          <td class="label-cell" style="border: 1px solid #000; padding: 6px 8px; font-weight: bold; background: #f8f9fa; text-transform: uppercase; font-size: 10pt;">POLY-OLIGO</td>
          <td class="value-cell" style="border: 1px solid #000; padding: 6px 8px; background: white; font-size: 11pt;">{{ getNoteValue('poly_oligo') }}</td>
        </tr>

        <!-- Row 13 -->
        <tr>
          <td class="label-cell" colspan="2" style="border: 1px solid #000; padding: 6px 8px; font-weight: bold; background: #f8f9fa; text-transform: uppercase; font-size: 10pt;">ADMITTED ON: CPAP MV NASAL O2</td>
          <td class="label-cell" style="border: 1px solid #000; padding: 6px 8px; font-weight: bold; background: #f8f9fa; text-transform: uppercase; font-size: 10pt;">FEVER</td>
          <td class="value-cell" style="border: 1px solid #000; padding: 6px 8px; background: white; font-size: 11pt;">{{ getNoteValue('fever') }}</td>
        </tr>

        <!-- Row 14 -->
        <tr>
          <td class="value-cell" colspan="2" style="border: 1px solid #000; padding: 6px 8px; background: white; font-size: 11pt;">{{ getNoteValue('admitted_on_cpap') }}</td>
          <td class="empty-cell" style="border: 1px solid #000; padding: 6px 8px; background: white;"></td>
          <td class="empty-cell" style="border: 1px solid #000; padding: 6px 8px; background: white;"></td>
        </tr>

        <!-- Row 15 -->
        <tr>
          <td class="label-cell" colspan="2" style="border: 1px solid #000; padding: 6px 8px; font-weight: bold; background: #f8f9fa; text-transform: uppercase; font-size: 10pt;">APGAR:</td>
          <td class="label-cell" style="border: 1px solid #000; padding: 6px 8px; font-weight: bold; background: #f8f9fa; text-transform: uppercase; font-size: 10pt;">UTI</td>
          <td class="value-cell" style="border: 1px solid #000; padding: 6px 8px; background: white; font-size: 11pt;">{{ getNoteValue('uti') }}</td>
        </tr>

        <!-- Row 16 -->
        <tr>
          <td class="value-cell" colspan="2" style="border: 1px solid #000; padding: 6px 8px; background: white; font-size: 11pt;">{{ getNoteValue('apgar') }}</td>
          <td class="empty-cell" style="border: 1px solid #000; padding: 6px 8px; background: white;"></td>
          <td class="empty-cell" style="border: 1px solid #000; padding: 6px 8px; background: white;"></td>
        </tr>

        <!-- Row 17 -->
        <tr>
          <td class="label-cell" colspan="2" style="border: 1px solid #000; padding: 6px 8px; font-weight: bold; background: #f8f9fa; text-transform: uppercase; font-size: 10pt;">PREVIOUS ADMISSION TO NICU:</td>
          <td class="label-cell" style="border: 1px solid #000; padding: 6px 8px; font-weight: bold; background: #f8f9fa; text-transform: uppercase; font-size: 10pt;">MOTHER BLOOD G:</td>
          <td class="value-cell" style="border: 1px solid #000; padding: 6px 8px; background: white; font-size: 11pt;">{{ getNoteValue('mother_blood_g') }}</td>
        </tr>

        <!-- Row 18 -->
        <tr>
          <td class="value-cell" colspan="2" style="border: 1px solid #000; padding: 6px 8px; background: white; font-size: 11pt;">{{ getNoteValue('previous_admission_to_nicu') }}</td>
          <td class="empty-cell" style="border: 1px solid #000; padding: 6px 8px; background: white;"></td>
          <td class="empty-cell" style="border: 1px solid #000; padding: 6px 8px; background: white;"></td>
        </tr>

        <!-- Row 19 -->
        <tr>
          <td class="label-cell" colspan="2" style="border: 1px solid #000; padding: 6px 8px; font-weight: bold; background: #f8f9fa; text-transform: uppercase; font-size: 10pt;">CONSANGUINTY:</td>
          <td class="label-cell" style="border: 1px solid #000; padding: 6px 8px; font-weight: bold; background: #f8f9fa; text-transform: uppercase; font-size: 10pt;">BABY BLOOD G:</td>
          <td class="value-cell" style="border: 1px solid #000; padding: 6px 8px; background: white; font-size: 11pt;">{{ getNoteValue('baby_blood_g') }}</td>
        </tr>

        <!-- Row 20 -->
        <tr>
          <td class="value-cell" colspan="2" style="border: 1px solid #000; padding: 6px 8px; background: white; font-size: 11pt;">{{ getNoteValue('consanguinty') }}</td>
          <td class="empty-cell" style="border: 1px solid #000; padding: 6px 8px; background: white;"></td>
          <td class="empty-cell" style="border: 1px solid #000; padding: 6px 8px; background: white;"></td>
        </tr>

        <!-- Row 21 -->
        <tr>
          <td class="label-cell" colspan="2" style="border: 1px solid #000; padding: 6px 8px; font-weight: bold; background: #f8f9fa; text-transform: uppercase; font-size: 10pt;">STEROID:</td>
          <td class="label-cell" style="border: 1px solid #000; padding: 6px 8px; font-weight: bold; background: #f8f9fa; text-transform: uppercase; font-size: 10pt;">THYROHD DISEASE:</td>
          <td class="value-cell" style="border: 1px solid #000; padding: 6px 8px; background: white; font-size: 11pt;">{{ getNoteValue('thyrohd_disease') }}</td>
        </tr>

        <!-- Row 22 -->
        <tr>
          <td class="value-cell" colspan="2" style="border: 1px solid #000; padding: 6px 8px; background: white; font-size: 11pt;">{{ getNoteValue('steroid') }}</td>
          <td class="empty-cell" style="border: 1px solid #000; padding: 6px 8px; background: white;"></td>
          <td class="empty-cell" style="border: 1px solid #000; padding: 6px 8px; background: white;"></td>
        </tr>
      </tbody>
    </table>

    <div class="footer">
      <p class="datetime">Date/Time: {{ formatDateTime(note.datetime) }}</p>
    </div>
  </div>
</template>

<script>
import { getNestedProperty } from '@/utils/nestedProperty.js';

export default {
  name: 'AdmissionNotePrint',
  props: {
    note: {
      type: Object,
      required: true
    },
    patientData: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    patientAge() {
      const birthDate = getNestedProperty(this.patientData, 'patient_card.patient.birth_date');
      if (!birthDate) return 'N/A';
      
      const birth = new Date(birthDate);
      const now = new Date();
      const diffMs = now - birth;
      const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
      
      if (diffDays < 30) {
        return `${diffDays} days`;
      } else if (diffDays < 365) {
        const months = Math.floor(diffDays / 30);
        return `${months} month${months > 1 ? 's' : ''}`;
      } else {
        const years = Math.floor(diffDays / 365);
        return `${years} year${years > 1 ? 's' : ''}`;
      }
    }
  },
  mounted() {
    // Component mounted
  },
  methods: {
    getNestedProperty,
    
    getNoteValue(field) {
      if (!this.note || !this.note.notes) {
        return '';
      }
      const notesData = typeof this.note.notes === 'string' 
        ? JSON.parse(this.note.notes) 
        : this.note.notes;
      
      // Handle array structure - get the first item if it's an array
      const data = Array.isArray(notesData) ? notesData[0] : notesData;
      
      return data[field] || '';
    },

    formatDateTime(dateTime) {
      if (!dateTime) return '';
      const d = new Date(dateTime);
      if (isNaN(d)) return dateTime;
      
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      let hours = d.getHours();
      const minutes = String(d.getMinutes()).padStart(2, '0');
      const ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12 || 12;
      
      return `${year}-${month}-${day} ${hours}:${minutes} ${ampm}`;
    }
  }
};
</script>

<style>
.admission-note-print {
  background: white;
  padding: 15mm;
  width: 210mm;
  min-height: 297mm;
  margin: 0 auto;
  font-family: Arial, sans-serif;
  color: #000;
  font-size: 12pt;
}

.header {
  text-align: center;
  margin-bottom: 15px;
  border-bottom: 2px solid #000;
  padding-bottom: 8px;
}

.header h1 {
  font-size: 16pt;
  font-weight: bold;
  margin: 0 0 3px 0;
  text-transform: uppercase;
}

.header h2 {
  font-size: 14pt;
  font-weight: bold;
  margin: 0;
  text-transform: uppercase;
}

.admission-table {
  width: 100% !important;
  border-collapse: collapse !important;
  border: 2px solid #000 !important;
  margin-bottom: 15px !important;
}

.admission-table td {
  border: 1px solid #000 !important;
  padding: 6px 8px !important;
  font-size: 11pt !important;
  vertical-align: top !important;
  height: 25px !important;
}

.label-cell {
  font-weight: bold !important;
  background: #f8f9fa !important;
  width: 20% !important;
  text-transform: uppercase !important;
  font-size: 10pt !important;
}

.value-cell {
  width: 30% !important;
  background: white !important;
  font-size: 11pt !important;
}

.large-cell {
  min-height: 60px;
  vertical-align: top;
}

.small-cell {
  font-size: 10pt;
}

.inline-label {
  font-weight: bold;
  margin-right: 5px;
}

.inline-label.ml {
  margin-left: 15px;
}

.empty-cell {
  background: white;
}

.footer {
  margin-top: 20px;
  text-align: right;
  font-size: 10pt;
}

.datetime {
  margin: 0;
  font-weight: bold;
}

/* Print styles */
@media print {
  * {
    -webkit-print-color-adjust: exact !important;
    color-adjust: exact !important;
  }

  .admission-note-print {
    padding: 10mm !important;
    width: 100% !important;
    margin: 0 !important;
    background: white !important;
  }

  .admission-table {
    width: 100% !important;
    border-collapse: collapse !important;
    border: 2px solid #000 !important;
    margin: 0 !important;
  }

  .admission-table td {
    padding: 4px 6px !important;
    height: 25px !important;
    border: 1px solid #000 !important;
    font-size: 10pt !important;
    vertical-align: middle !important;
    background: white !important;
  }

  .label-cell {
    background: #f8f9fa !important;
    font-weight: bold !important;
    text-transform: uppercase !important;
  }

  .value-cell {
    background: white !important;
    font-weight: normal !important;
  }

  .header {
    text-align: center !important;
    margin-bottom: 20px !important;
    border-bottom: 2px solid #000 !important;
    padding-bottom: 10px !important;
  }

  .header h1 {
    font-size: 18pt !important;
    font-weight: bold !important;
    margin: 0 0 5px 0 !important;
  }

  .header h2 {
    font-size: 16pt !important;
    font-weight: bold !important;
    margin: 0 !important;
  }

  @page {
    size: A4;
    margin: 10mm;
  }
}
</style>

